/* --------------------------------------------------------------------------------------
   xwTable.directive.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwTable {
  /*@ngInject*/
  constructor () {
    this.restrict = 'A'
    this.scope = false
  }
  link(scope, elem, attrs) {
    var options = {
      bordered : attrs.bordered,
      striped : attrs.striped,
      width : attrs.width,
      height : attrs.height,
      scroll : attrs.scroll
    }
    setTimeout(() => {
      elem.first().xrxtable(options)
    })

    elem.on('$destroy', () => {
      elem.first().xrxtable('destroy')
      elem = null
    })
  }
  static directiveFactory() {
    xwTable.instance = new xwTable()
    return xwTable.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwTable.directive.js